import { render } from "./Campaigns.vue?vue&type=template&id=538c7df1&ts=true"
import script from "./Campaigns.vue?vue&type=script&lang=ts"
export * from "./Campaigns.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__